<template>
  <div class="navbar flex item-center">
    <span
      class="hamburger hmicon icon-hanbaobao"
      :class="{ 'is-active': sidebar.opened }"
      @click="toggleSideBar"
    ></span>
    <!-- <hm-breadcrumb /> -->

    <span
      class="storeName text-overflow"
      :title="storeName || storageStoreName"
      >{{ storeName || storageStoreName }}</span
    >
    <a
      style="color:#fff"
      href="https://www.kancloud.cn/hemiao/hxnew/1416898"
      target="_blank"
      >帮助文档</a
    >

    <div class="expiration pointer" @click="expiration">
      <el-badge is-dot class="badge" :hidden="isBadge">
        <span class="hmicon icon-lixianhuanxing" style="fontSize:29px"></span>
      </el-badge>
    </div>
    <div>
      <!-- <div class="avatar-container mr20"> -->
      <el-autocomplete
        class="inline-input mr20"
        v-model="queryMenuName"
        :fetch-suggestions="querySearch"
        placeholder="搜菜单"
        :trigger-on-focus="false"
        @select="handleSelect"
        clearable
         popper-class="auto-adjust-el-autocomplete-suggestion"
      ></el-autocomplete>
      <!-- </div> -->
      <el-dropdown class="avatar-container mr20" trigger="click">
        <div class="avatar-wrapper flex item-center">
          <span class="user-name">欢迎您{{ realname }}！</span>
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <!-- <router-link class="inlineBlock" to="/">
          <el-dropdown-item>首页</el-dropdown-item>
        </router-link> -->
          <el-dropdown-item>
            <span style="display:block;" @click="set">设置</span>
          </el-dropdown-item>
          <el-dropdown-item v-if="thirdTypeFlag" divided>
            <span style="display:block;" @click="removeBindingWx('wechat_open')"
              >解除绑定</span
            >
          </el-dropdown-item>
          <el-dropdown-item v-else divided>
            <span style="display:block;" @click="goBindingWx('wechat_open')"
              >去绑定微信</span
            >
          </el-dropdown-item>
          <el-dropdown-item>
            <span style="display:block;">当前版本号: {{version}}</span>
          </el-dropdown-item>
          <el-dropdown-item divided>
            <span style="display:block;" @click="logout">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dialog
        :close-on-click-modal="false"
        title="到期提醒"
        width="1000px"
        :visible.sync="dialogVisible"
      >
        <div>
          <div class="flex flex-center">
            <span
              class="hmicon icon-tishi"
              style="fontSize:50px;color:rgb(243, 174, 64)"
            ></span>
          </div>
          <div class="flex flex-center" style="fontSize:20px;fontWeight:600">
            您的商城服务将于
            <span class="primary">{{
              expirationReminder.cooperativeStartEnd
            }}</span>
            到期
          </div>
          <div class="flex flex-center form-item-tip" style="fontSize:15px">
            请尽快联系您的运营或市场经理进行续费。
            服务到期后，商品列表不再展示，订单在线支付功能等被停用。
          </div>
        </div>
        <span slot="footer" class="dialog-footer flex flex-center">
          <el-button @click="dialogVisible = false" size="small" type="info"
            >关 闭</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
        title="提示"
        :close-on-click-modal="false"
        :visible.sync="dialogVisibleWechat"
        width="600px"
      >
        <div
          class="primary text-center"
          style="font-size: 19px;font-weight: 600;"
        >
          为了您的账号安全，请您绑定微信，方便微信扫码登录
        </div>
        <span slot="footer">
          <div class="dialog-footer flex flex-center">
            <el-button
              @click="goBindingWx('wechat_open')"
              size="small"
              type="primary"
              >去绑定</el-button
            >
            <el-button
              @click="dialogVisibleWechat = false"
              size="small"
              type="info"
              >暂不绑定</el-button
            >
          </div>
          <div class="tips flex flex-center">
            点击右上角登录账号可以设置是否弹窗规则
          </div>
        </span>
      </el-dialog>
      <el-dialog
        title="弹出设置"
        :close-on-click-modal="false"
        :visible.sync="dialogVisibleSet"
        width="600px"
      >
        <div class="primary flex flex-column">
          <template>
            <el-radio-group v-model="paramValue.type" size="small">
              <el-radio class="radio" label="interval"
                >设置弹出时间间隔:
                <el-input
                  clearable
                  size="small"
                  v-model.trim="paramValue.day"
                  placeholder="请输入天数"
                  @input="filterGt0OrFixed()"
                  maxlength="2"
                ></el-input>
                天后下一次弹出</el-radio
              >
              <el-radio class="radio" label="all">每次更新页面弹出</el-radio>
              <el-radio class="radio" label="no">不再弹出</el-radio>
            </el-radio-group>
          </template>
        </div>
        <span slot="footer" class="dialog-footer flex flex-center">
          <el-button size="small" type="primary" @click="save">确 定</el-button>
          <el-button size="small" @click="close">取 消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import HmBreadcrumb from "@/components/HmBreadcrumb";
import { getLoginUser, getToken, setLoginUser } from "@/utils/auth";
import { setCookie, getCookie } from "@/utils/utils";
import { server } from "../../../utils/request";
export default {
  components: {
    // HmBreadcrumb
  },
  computed: {
    ...mapGetters(["sidebar", "name", "storeName", "expirationReminder"])
  },
  data() {
    return {
      dialogVisibleSet: false,
      dialogVisibleWechat: false,
      isBadge: true,
      dialogVisible: false,
      role: "",
      realname: "",
      storageStoreName: "",
      thirdTypeFlag: true,
      num: 0,
      names: "",
      radio: "2",
      day: "",
      paramValue: {
        type: "all",
        day: "",
        upDateTime: ""
      },
      version: "",
      isShow: true,
      queryMenuName: ""
    };
  },
  created() {
    console.log('Git commit version:', process.env.VERSION);
    this.version = process.env.VERSION;
    this.$store.dispatch("queryStoreName").then(res => {
      if (res.result.cooperativeState === "false") {
        if (this.dateDiff(this.expirationReminder.cooperativeStartEnd) <= 60) {
          this.isBadge = false;
          this.tishi();
        }
      }
    });
  },
  beforeDestroy() {
    //在组件生命周期结束的时候销毁。
    window.removeEventListener("message", this.receiveMessage);
  },
  mounted() {
    if (getLoginUser().roles && getLoginUser().roles.length) {
      this.role = getLoginUser().roles[0];
      this.names = getLoginUser().username;
    }
    console.log(getLoginUser(),'真名')
    this.realname = getLoginUser().realname;
    this.queryAllThirdTypeList();
    this.queryByCodeAllowNull();
  },
  methods: {
    async querySearch(queryString, cb) {
      const params = {
        queryMenuName: this.queryMenuName,
        systemCode: "store"
      };
      const { result } = await this.$store.dispatch(
        "searchUserPermission",
        params
      );
      if (result) {
        this.restaurants = result.metaList;
        this.restaurants.forEach(v => {
          v.value = v.name;
        });
        var results = this.restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);
      }
    },
    handleSelect(item) {
      console.log(item);
      this.$router.push({
        path: item.url
      });
      this.queryMenuName = "";
    },
    async queryAllThirdTypeList() {
      const { result } = await this.$store.dispatch("queryAllThirdTypeList");
      this.thirdTypeFlag = result.length > 0 ? true : false;
      // this.dialogVisibleWechat = !this.thirdTypeFlag;
    },
    tishi() {
      const h = this.$createElement;
      this.$notify({
        title: "新消息",
        type: "warning",
        message: h(
          "p",
          {
            style: "cursor: pointer",
            on: {
              click: this.go
            }
          },
          [
            h("span", null, "您的商城服务将于"),
            h(
              "a",
              {
                style: "color: #E50065",
                on: {
                  click: this.go
                }
              },
              `${this.expirationReminder.cooperativeStartEnd}`
            ),
            h("span", null, "到期,请尽快联系您的运营或市场经理进行续费。")
          ]
        ),
        position: "top-right",
        duration: 0
      });
    },
    dateDiff() {
      //sDate1和sDate2是2006-12-18格式

      let aDate, oDate1, oDate2, iDays;
      aDate = this.expirationReminder.cooperativeStartEnd.split("-"); //调用Date的构造函数，转换为12-18-2006格式
      oDate1 = new Date(aDate[0], aDate[1] - 1, aDate[2]);
      let nowDate = new Date();
      let date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate()
      };
      if (date.month >= 1 && date.month <= 9) {
        date.month = "0" + date.month;
      }
      if (date.date >= 0 && date.date <= 9) {
        date.date = "0" + date.date;
      }
      oDate2 = oDate2 = new Date(date.year, date.month - 1, date.date); //把相差的毫秒数转换为天数
      iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24);
      return iDays;
    },
    filterGt0OrFixed() {
      this.paramValue.day = this.paramValue.day.replace(/^(0+)/, ""); //过滤0开头
      this.paramValue.day = this.paramValue.day.replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.paramValue.day = this.paramValue.day.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.paramValue.day = this.paramValue.day
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.paramValue.day = this.paramValue.day.replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      this.paramValue.day = this.paramValue.day.replace(/\./g, "");
      if (this.paramValue.day.indexOf(".") < 0 && this.paramValue.day != "") {
        //首位是0的话去掉
        this.paramValue.day = parseFloat(this.paramValue.day);
      }
    },
    expiration() {
      if (!this.isBadge) {
        this.dialogVisible = true;
      }
    },
    go() {},
    toggleSideBar() {
      this.$store.dispatch("ToggleSideBar");
    },
    async removeBindingWx(thirdType) {
      const userInfo = getLoginUser() || "";
      if (!userInfo || !userInfo.thirdUserUuid) {
        return;
      }
      await this.$store.dispatch("unbindingSelfThirdAccount", {
        thirdType,
        thirdUserUuid: userInfo.thirdUserUuid
      });
      this.queryAllThirdTypeList();
      this.$message({
        message: "解除绑定成功！",
        type: "success"
      });
    },
    goBindingWx(thirdType) {
      let address;
      if (process.env.NODE_ENV === "production") {
        const isTestServer = window.location.host.includes("hexin");
        // 线上地址
        address = isTestServer ? server.service.test : server.service.prod;
      } else {
        // 本地调试地址
        address = server.service.test;
      }
      let url = address + "/sys/thirdLogin/render/wechat_open";
      window.open(
        url,
        `login`,
        "height=500, width=500, top=0, left=0, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=n o, status=no"
      );
      let that = this;

      this.receiveMessage = function(event) {
        if (that.num > 0) {
          return;
        }
        // console.log("event12312: ", event);
        let token = event.data;

        that.num++;
        // window.removeEventListener("message", that.receiveMessage);
        if (token.type === "webpackWarnings") {
          return;
        }
        if (typeof token === "string") {
          //如果是字符串类型 说明是token信息
          if (token === "登录失败") {
            that.$message({
              message: token,
              type: "warning"
            });
          } else if (token.includes("绑定账号")) {
            let strings = token.split(",");
            let params = {
              thirdUserUuid: strings[1],
              thirdType
            };
            const userInfo = getLoginUser() || "";
            userInfo.thirdUserUuid = strings[1];
            setLoginUser(userInfo);
            that.$store.dispatch("targetThirdAccount", params).then(() => {
              that.$message({
                message: "绑定成功！",
                type: "success"
              });
              that.queryAllThirdTypeList();
            });

            // setCookie({
            //   key: "UUID_INFO",
            //   type: "session",
            //   data: JSON.stringify(params)
            // });
            // that.$store.commit("UUID_INFO", params);
            // that.$router.push({
            //   name: "wxlogin"
            // });
          } else {
            that.$message({
              message: "该微信号已绑定账号！",
              type: "warning"
            });
          }
        }

        // that.thirdUserUuid = strings[1];
        // sessionStorage.removeItem("USER_MENU");
        // that.$store.dispatch("LogOut", getToken()).then(() => {
        //   that.$router.push({ name: "wxlogin" });
        //   location.reload(); // 为了重新实例化vue-router对象 避免bug
        // });

        // if (typeof token === "string") {
        //   //如果是字符串类型 说明是token信息
        //   if (token === "登录失败") {
        //     that.$message({
        //       message: token,
        //       type: "warning"
        //     });
        //     // that.$message.warning(token);
        //   } else if (token.includes("绑定账号")) {
        //     // that.bindingPhoneModal = true;
        //     let strings = token.split(",");
        //     // that.thirdUserUuid = strings[1];
        //     sessionStorage.removeItem("USER_MENU");
        //     that.$store.dispatch("LogOut", getToken()).then(() => {
        //       that.$router.push({ name: "wxlogin" });
        //       location.reload(); // 为了重新实例化vue-router对象 避免bug
        //     });
        //     that.$router.push({
        //       name: "wxlogin"
        //     });
        //     let params = {
        //       wxLoginUuid: strings[1],
        //       thirdType
        //     };
        //     that.$store.commit("UUID_INFO", params);
        //   } else {
        //     // that.doThirdLogin(token);

        //     let params = {
        //       thirdType,
        //       token
        //     };
        //     that.$store.dispatch("queryUserInfoByToken", params).then(() => {
        //       that.loading = false;
        //       let path = "/";
        //       setTimeout(() => {
        //         if (sessionStorage.getItem("USER_MENU") === "0") {
        //           const h = that.$createElement;
        //           that.$notify({
        //             title: "提示",
        //             message: h(
        //               "span",
        //               { style: "color: teal" },
        //               "该角色账户无权限!"
        //             ),
        //             type: "warning"
        //           });
        //         }
        //       }, 1000);
        //       if (that.redirect) {
        //         path = that.redirect;
        //       }
        //       that.$router
        //         .push({
        //           path,
        //           query: {
        //             from: "login"
        //           }
        //         })
        //         .catch(() => {});
        //     });
        //   }
        // } else if (typeof token === "object") {
        //   //对象类型 说明需要提示是否绑定现有账号
        //   if (token["isObj"] === true) {
        //     that.thirdConfirmShow = true;
        //     that.thirdLoginInfo = { ...token };
        //   }
        // } else {
        //   that.$message.warning("不识别的信息传递");
        // }
      };
      this.$forceUpdate();
      window.addEventListener("message", this.receiveMessage, false);
    },
    logout() {
      sessionStorage.removeItem("USER_MENU");
      this.$store.dispatch("LogOut", getToken()).then(() => {
        this.$router.push({ name: "Login" });
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    },
    set() {
      this.dialogVisibleSet = true;
    },
    save() {
      this.saveOrUpdate();
      this.dialogVisibleSet = false;
    },
    close() {
      this.dialogVisibleSet = false;
    },
    async queryByCodeAllowNull() {
      const userInfo = getLoginUser() || "";
      if (!userInfo) {
        return;
      }
      console.log("userInfo:", userInfo);
      let params = {
        userType: "storeUserId",
        userId: userInfo.exportId,
        paramCode: "wxchat_scan_qrcode_login_popup_setting"
      };
      const { result } = await this.$store.dispatch(
        "queryByCodeAllowNull",
        params
      );
      if (result) {
        this.paramValue = JSON.parse(result.paramValue);
        console.log("this.paramValue:", this.paramValue);
      }
      if (this.paramValue.type === "all") {
        this.isShow = true;
      } else if (this.paramValue.type === "no") {
        this.isShow = false;
      } else if (this.paramValue.type === "interval") {
        console.log(
          "this.dateDiff(this.paramValue.upDateTime):",
          this.dateDiff(this.paramValue.upDateTime)
        );
        console.log("this.paramValue.day", parseInt(this.paramValue.day));
        if (
          this.dateDiff(this.paramValue.upDateTime) >=
          parseInt(this.paramValue.day)
        ) {
          this.isShow = true;
          this.saveOrUpdate();
        } else {
          this.isShow = false;
        }
      }
      this.dialogVisibleWechat = !this.thirdTypeFlag && this.isShow;
    },
    async saveOrUpdate() {
      const userInfo = getLoginUser() || "";
      if (!userInfo) {
        return;
      }
      console.log("userInfo:", userInfo);
      let nowDate = new Date();
      let date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate()
      };
      this.paramValue.upDateTime =
        nowDate.getFullYear() +
        "-" +
        (nowDate.getMonth() + 1) +
        "-" +
        nowDate.getDate();
      let params = {
        userType: "storeUserId",
        userId: userInfo.exportId,
        paramCode: "wxchat_scan_qrcode_login_popup_setting",
        paramValue: JSON.stringify(this.paramValue)
      };
      await this.$store.dispatch("saveOrUpdate", params).then(() => {
        this.$message({
          message: "操作成功！",
          type: "success"
        });
      });
    },
    dateDiff(setDay) {
      //sDate1和sDate2是2006-12-18格式
      let aDate, oDate1, oDate2, iDays;
      aDate = setDay.split("-"); //调用Date的构造函数，转换为12-18-2006格式
      oDate1 = new Date(aDate[0], aDate[1] - 1, aDate[2]);
      let nowDate = new Date();
      let date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate()
      };
      if (date.month >= 1 && date.month <= 9) {
        date.month = "0" + date.month;
      }
      if (date.date >= 0 && date.date <= 9) {
        date.date = "0" + date.date;
      }
      oDate2 = oDate2 = new Date(date.year, date.month - 1, date.date); //把相差的毫秒数转换为天数
      iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24);
      return iDays;
    }
  }
};
</script>
<style lang="scss">
.badge {
  .el-badge__content {
    margin-top: 10px;
  }
}
</style>
<style rel="stylesheet/scss" lang="scss" scoped>
@media screen and (max-width: 500px) {
  .navbar {
    .storeName {
      width: 100px;
      color: #fff;
    }
  }
}
.navbar {
  position: relative;
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  background: #e50163;
  .expiration {
    position: absolute;
    right: 20px;
  }
  .storeName {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 14px;
    color: #fff;
  }
  .hmicon {
    color: #fff;
  }
  .hamburger {
    display: block;
    cursor: pointer;
    padding: 0 10px;
    transform: rotate(90deg);
  }
  .hamburger.is-active {
    transform: rotate(0deg);
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    top: 0;
    .avatar-wrapper {
      cursor: pointer;
      position: relative;
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .user-name {
        color: #fff;
      }
      .el-icon-caret-bottom {
        color: #fff;
      }
    }
  }
}
.tips {
  color: #2aa4d9;
}
.radio {
  line-height: 50px;
  display: block;
}
.inline-input {
  position: absolute;
  top: 0;
  right: 200px;
}
</style>
